import { LearningType } from "./LearningType";

export default class LearningContinue {
  id: number;
  learningType: LearningType;
  learningGroup: string[];
  learningLevel: number[];
  seed: number;
  itemSize: number;
  currentIndex: number;
  currentPage: number;
  createdAt: string;

  constructor(
    id: number,
    learningType: LearningType,
    learningGroup: string[],
    learningLevel: number[],
    seed: number,
    itemSize: number,
    currentIndex: number,
    currentPage: number,
    createdAt: string
  ) {
    this.id = id;
    this.learningType = learningType;
    this.learningGroup = learningGroup;
    this.learningLevel = learningLevel;
    this.seed = seed;
    this.itemSize = itemSize;
    this.currentIndex = currentIndex;
    this.currentPage = currentPage;
    this.createdAt = createdAt;
  }

  static fromJson(json: any): LearningContinue {
    const learningTypeValue = json.learningType ?? 1;
    let learningType: LearningType = LearningType.flashcards;

    switch (learningTypeValue) {
      case 1:
      case "1":
        learningType = LearningType.flashcards;
        break;
      case 2:
      case "2":
        learningType = LearningType.multiplechoice;
        break;
      case 3:
      case "3":
        learningType = LearningType.spellingQuiz;
        break;
      default:
        learningType = LearningType.flashcards;
        break;
    }

    const learningGroupStringValue = json.learningGroup ?? "";
    const learningGroup = learningGroupStringValue
      .split(",")
      .map((s: string) => s.trim());

    const learningLevelStringValue = json.learningLevel ?? "";
    const learningLevel = learningLevelStringValue
      .split(",")
      .map((s: string) => parseInt(s.trim(), 10))
      .filter((n: number) => !isNaN(n));

    return new LearningContinue(
      Number(json.id ?? 0),
      learningType,
      learningGroup,
      learningLevel,
      Number(json.seed ?? 0),
      Number(json.itemSize ?? 0),
      Number(json.currentIndex ?? 0),
      Number(json.currentPage ?? 0),
      json.createdAt ?? ""
    );
  }
}
